import axios from './api';
import { getUrl } from './utils';
const endPoint = getUrl('api') + '/api/v2/concretebatch';

export const getConcreteBatches = async ({ project, filters, size }) => {
  return axios.get(
    `${endPoint}?project=${project}${Object.entries(filters)
      .map(([keyBy, value]) => `&${keyBy}=${value}`)
      .join('')}&size=${size}`,
  );
};

export const deleteConcreteBatch = async (id) => {
  return axios.delete(`${endPoint}/${id}`);
};

export const createConcreteBatch = async (data) => {
  return axios.post(endPoint, data);
};
